"use client";

import { motion } from "framer-motion";
import { SectionHeading } from "@/components/ui/section-heading";
import { CodeTabs, EnvPreamble, modelSnippets } from "@/components/dashboard/code-snippets";
import { PLAYGROUND_MODELS } from "@/lib/dashboard/models";
import { PUBLIC_API_V1_HOST } from "@/lib/api/public-url";
import { fadeUp } from "@/lib/motion";
import { GeoAccent } from "@/components/ui/geo-art";

/**
 * "Start in thirty seconds" on `/developers`: the same cURL, Python and Node
 * snippets the dashboard's model cards and the docs use, for the first live
 * chat route in the catalogue. One source, so the three surfaces cannot show
 * three different ways to make the same call.
 */
const MODEL = PLAYGROUND_MODELS[0];

export function DevQuickstart() {
  return (
    <section id="quickstart" className="relative scroll-mt-24">
      <div className="mx-auto max-w-[90rem] px-5 py-14 sm:px-8 sm:py-24">
        <SectionHeading align="left" eyebrow="Start in thirty seconds" title="Point any OpenAI SDK at P/9 and call a model." />
        <p className="mt-5 max-w-2xl font-sans text-sm leading-relaxed text-muted">
          Point any OpenAI-compatible SDK at{" "}
          <code className="rounded bg-card-2 px-1.5 py-0.5 font-mono text-[0.85em] text-foreground">{PUBLIC_API_V1_HOST}</code>, swap in your P/9 API key, and call the
          model you need. Existing agents, tool chains and RAG pipelines work without code changes.
        </p>
        <div className="mt-10 lg:grid lg:grid-cols-[minmax(0,48rem)_minmax(0,1fr)] lg:items-center lg:gap-16">
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
            className="flex min-w-0 flex-col gap-3"
          >
            <EnvPreamble />
            {MODEL && <CodeTabs tabs={modelSnippets(MODEL)} />}
          </motion.div>
          <div className="hidden lg:block">
            <GeoAccent variant="brackets" className="mx-auto max-w-[15rem]" />
          </div>
        </div>
      </div>
    </section>
  );
}
